// extracted by mini-css-extract-plugin
export var active = "footer-module--active--7f5b9";
export var address = "footer-module--address--3d3eb";
export var bottom = "footer-module--bottom--d6602";
export var bottomLinks = "footer-module--bottomLinks--24247";
export var branding = "footer-module--branding--5a01e";
export var contacts = "footer-module--contacts--ed849";
export var copyright = "footer-module--copyright--e54b7";
export var customGrid = "footer-module--customGrid--e5bb2";
export var heading = "footer-module--heading--34ef3";
export var item = "footer-module--item--9906c";
export var itemAccordion = "footer-module--itemAccordion--cb9cb";
export var itemContacts = "footer-module--itemContacts--c005d";
export var linkList = "footer-module--linkList--b52e3";
export var root = "footer-module--root--428e0";
export var top = "footer-module--top--00449";